"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.millisecondsToTimer = millisecondsToTimer;
exports.getUsageTrackerWithNamespaceMaybeUpdated = getUsageTrackerWithNamespaceMaybeUpdated;
exports.getUsageTrackerJsEventName = getUsageTrackerJsEventName;

var _I18n = _interopRequireDefault(require("I18n"));

function millisecondsToTimer(milliseconds) {
  if (!milliseconds) {
    return null;
  }

  if (milliseconds < 3600000) {
    return _I18n.default.moment.utc(milliseconds).format('mm:ss');
  }

  return _I18n.default.moment.utc(milliseconds).format('HH:mm:ss');
}

function getUsageTrackerOverwriteProperties(usageTracker) {
  return {
    properties: {
      namespace: 'file-picker',
      'in-app': usageTracker.config.properties ? usageTracker.config.properties.namespace : 'unknown',
      screen: 'picker'
    }
  };
}

function getUsageTrackerWithNamespaceMaybeUpdated(usageTracker) {
  return usageTracker && !usageTracker.trackInteraction && usageTracker.config ? usageTracker.clone(getUsageTrackerOverwriteProperties(usageTracker)) : usageTracker;
}

function getUsageTrackerJsEventName(hublyticsEventName) {
  switch (hublyticsEventName) {
    case 'Manage Files':
      return 'fileManagerManageFiles';

    case 'Browse Shutterstock':
      return 'fileManagerBrowseShutterstock';

    case 'Accept Video TOS':
      return 'fileManagerAcceptVideoTOS';

    default:
      return '';
  }
}